import { removeScopedStates, saveState } from './persistStateActions';
import { createReducer } from '@reduxjs/toolkit';
import { resetPersistState } from './persistStateActions';
import { isArray } from 'lodash';

export type PersistState = Record<string, unknown>;

const DEFAULT_STATE: PersistState = {};

export const DEFAULT_PERSIST_STATE_SCOPE = '_default';

export const persistStateReducer = createReducer(DEFAULT_STATE, (builder) => {
    builder.addCase(resetPersistState, () => DEFAULT_STATE);

    builder.addCase(saveState, (state, { payload: { scope = DEFAULT_PERSIST_STATE_SCOPE, persistKey, payload } }) => {
        state[scope] = {
            ...(state[scope] as Record<string, unknown>),
            [persistKey]: payload,
        };
    });

    builder.addCase(removeScopedStates, (state, { payload: scope }) => {
        if (isArray(scope)) {
            scope.forEach((item) => {
                delete state[item];
            });
        } else {
            delete state[scope];
        }
    });
});
